import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LineChart } from '@mui/x-charts/LineChart';
import { useGetDataChartsMutation } from '../services/home';
const BASE_NAME = process.env.REACT_APP_BASE_NAME;

export default function Dashboard() {
  if(!window.localStorage.getItem('token'))
    window.location.href = `${BASE_NAME}/login`;

  const navigate = useNavigate();
  const [getDataCharts, dataCharts] = useGetDataChartsMutation();
  const [dataLoaded, setDataLoaded] = useState({xLabels: [], data: []});

  const margin = { right: 24 };
  const user = JSON.parse(window.localStorage.getItem("user"));
  const functions = JSON.parse(user.functions||"[]");

  useEffect(() => {
    if(user.id == 89)
      navigate('/kpidashboard');
    else if(functions.find(f=>f.Form == "orders"))
      navigate('/orders');
    else if(user.id != 89 && functions.find(f=>f.Form == "replenishment"))
      navigate('/replenishment');
    else if(user.username == "tcm")
      navigate('/consumerlist');
    else if(functions.find(f=>f.Form == "kpidashboard"))
      getDataCharts({'year': 2025});
    else if(functions.find(f=>f.Form == "sellingrate"))
      navigate('/sellingrate');
    else
      navigate(functions[0] ? `/${functions[0].Form.toLowerCase()}` : '/');
  }, []);

  useEffect(() => {
    if(dataCharts.data)
    {
      const dt = JSON.parse(dataCharts.data);
      let channel = [];
      let xLabels = [];
      let data = [];
      const dateMonth = new Date();
      dt.map(m=>{
        dateMonth.setMonth(m.MONTH);
        const monthName = dateMonth.toLocaleString('default', { month: 'short' });
        if(!xLabels.includes(monthName))
          xLabels.push(monthName);
        if(!channel.includes(m.Channel))
          channel.push(m.Channel);
      });
      channel.map(m=>{
        data.push({label: m, data: dt.filter(f=>f.Channel == m).map(c=>c.Amount)});
      })
      
      setDataLoaded({xLabels: xLabels, data: data});
    }
  }, [dataCharts]);

  return (
    <div>
      <LineChart
        height={300}
        series={dataLoaded.data}
        xAxis={[{ scaleType: 'point', data: dataLoaded.xLabels }]}
        yAxis={[{ width: 50 }]}
        margin={margin}
      />
    </div>
  )
}